import { render, staticRenderFns } from "./BubbleChart.vue?vue&type=template&id=528d1138&scoped=true&"
import script from "./BubbleChart.vue?vue&type=script&lang=js&"
export * from "./BubbleChart.vue?vue&type=script&lang=js&"
import style0 from "./BubbleChart.vue?vue&type=style&index=0&id=528d1138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528d1138",
  null
  
)

export default component.exports